import { render, staticRenderFns } from "./edit-car-button.vue?vue&type=template&id=5fc43b64"
import script from "./edit-car-button.vue?vue&type=script&lang=js"
export * from "./edit-car-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports